import { Button } from "flowbite-react";
import React from "react";
import { useNavigate } from "react-router";

function Hero() {
    const navigate = useNavigate();
  return (
    <section className="relative bg-[url('./img/banner-1.jpg')] bg-cover bg-center bg-no-repeat min-h-[350px] md:min-h-[600px] flex flex-col justify-center items-center space-y-8 py-14">
      <div className="absolute top-[15%] left-[5%] flex flex-col space-y-7">
        <div>
        <h3 className="text-2xl font-semibold text-white">
        YOUR TRUSTED FINANCING
        </h3>
        <h3 className="text-2xl font-semibold text-white sm:ml-[4ch]">       
        PARTNERS, ONE FOR ALL
        </h3>
        </div>
        <Button
            className="!bg-transparent border-2 !border-white w-[95%] md:w-[200px] hover:shadow-lg hover:-translate-x-px hover:translate-y-px hover:shadow-[#244565]/50"
            onClick={() => navigate("/services")}
        >
            Learn more
        </Button>
      </div>
    </section>
  );
}

export default Hero;
